import React from "react";
import { useTranslation } from "react-i18next";
import PrayerRequestForm from "../ministries/PrayerRequestForm";

const PrayerRequestPanel = () => {
  const { t } = useTranslation(["common", "prayerRequest"]);

  const handleSuccess = () => {
    console.log("Prayer request successfully submitted.");
  };

  return (
    <div className="container-fluid p-0 m-0">
      <div
        className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-end w-100"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/MarianCandle.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "1rem",
        }}
      >
        <div
          className="card shadow-lg border-0 w-100"
          style={{
            maxWidth: "600px",
            backgroundColor: "#ffffffee",
          }}
        >
          <div className="card-header text-white text-center p-3">
            <h5 className="mb-0">
              {t("prayerRequest:subtitle") || "Submit a Prayer Request"}
            </h5>
          </div>
          <div className="card-body px-3 px-md-4 py-4">
            <p className="text-muted text-center mb-1">
              {t("prayerRequest:panelDescription") ||
                "Let us pray with you. Fill out the form below."}
            </p>
            <PrayerRequestForm onSuccess={handleSuccess} t={t} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrayerRequestPanel;
